import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: [],
  },
  mutations: {
    setToken (state, token) {
      state.token = token;
    },
  },
  actions: {
    toekn (context, data) {
      context.commit('setToken', data);
    },
  },
  modules: {
    common,
  },
});
